import { Stack, Divider } from '@mui/material'

export const LiveFeedDivider = () => {
  return (
    <Stack direction="row" justifyContent="center">
      <Divider variant="middle" sx={{ width: '50%', color: '#d6d6d6' }} />
    </Stack>
  )
}

export default LiveFeedDivider
